import { render, staticRenderFns } from "./PageImage.vue?vue&type=template&id=86b61e18&scoped=true"
import script from "./PageImage.vue?vue&type=script&lang=js"
export * from "./PageImage.vue?vue&type=script&lang=js"
import style0 from "./PageImage.vue?vue&type=style&index=0&id=86b61e18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b61e18",
  null
  
)

export default component.exports